module.exports = __webpack_public_path__ + "img/5.e68e4284.jpg";